var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationFailed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10087_13651)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10087_13651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0004 7.33296V10.9999M11.0004 14.6669H11.0096M20.1678 10.9999C20.1678 16.0629 16.0634 20.1673 11.0004 20.1673C5.93739 20.1673 1.83301 16.0629 1.83301 10.9999C1.83301 5.9369 5.93739 1.83252 11.0004 1.83252C16.0634 1.83252 20.1678 5.9369 20.1678 10.9999Z",
    stroke: "#E11D48",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10087_13651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10087_13651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationFailed);
export default __webpack_public_path__ + "static/media/notification-failed.2fa24eb11a9e138b41daea79a9335879.svg";
export { ForwardRef as ReactComponent };